import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface MarkChatReadInput {
    channel: 'internal' | 'vendor';
    orderId?: string;
    supplierOrderId?: string;
}

const markChatRead = async (sessionId: string, input: MarkChatReadInput): Promise<void> => {
    await axios.post(`${API_URL}/chats/read`, input, {
        headers: { Authorization: sessionId },
    });
};

export const useMarkChatRead = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: MarkChatReadInput) => {
            if (!sessionContext?.sessionId) throw new Error('Not authenticated');
            return markChatRead(sessionContext.sessionId, input);
        },
        onSuccess: () => {
            // Update the New Chat badge. The feed is NOT invalidated here — the UI
            // marks the thread read optimistically and keeps its position; the next
            // poll reconciles without reordering on click.
            queryClient.invalidateQueries({ queryKey: ['/notifications'] });
        },
    });
};
